if (!customElements.get('collection-variant-selector')) {
  class CollectionVariantSelector extends HTMLElement {
    constructor() {
      super();
    }

    async connectedCallback() {
      this.parentProduct = this.getAttribute("data-parent");

      if (this.parentProduct) {
        this.releatedProducts = await this.fetchReleatedProducts(this.parentProduct);
        let colorsInnerHTML = "";
        let imagesInnerHTML = "";

        this.releatedProducts.forEach((p, i) => {
          if (i < 5) {
            // Farben anzeigen
            if (themeSwatch[p.search_color]) {
              colorsInnerHTML += `
                <span class="product-sibling-color" 
                      style="background-color: ${themeSwatch[p.search_color]}" 
                      title="${p.color}">
                </span>
              `;
            }

            // Bild mit max. 70x70 px und Produktlink
            if (p.featuredImage?.url) {
              let smallImageUrl = p.featuredImage.url.replace(".jpg", "_70x70.jpg").replace(".png", "_70x70.png");
              imagesInnerHTML += `
                <a href="/products/${p.handle}" title="${p.title}" 
                   data-color="${p.color}" 
                   class="product-sibling ${i > 3 ? 'hidden-mobile' : ''} sibling-link">
                  <img src="${smallImageUrl}" width="70" height="70" alt="${p.title}" class="sibling-image">
                </a>
              `;
            }
          } 
          
          // Falls mehr als 5 Varianten existieren, füge "+X" an
          else if (i === 5) {
            const remaining = this.releatedProducts.length - 5;
            imagesInnerHTML += `<span class="product-sibling-plus">[+${remaining}]</span>`;
          }
        });

        this.querySelector(".product-sibling-colors").innerHTML = colorsInnerHTML;
        this.querySelector(".product-sibling-images").innerHTML = imagesInnerHTML;
      }
    }

    async fetchReleatedProducts(parentProduct) {
      const response = await fetch("/api/2024-10/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": "d94897c58265199f651fa66fabf42404",
        },
        body: JSON.stringify({
          variables: {
            first: 100,
            query: `tag:"parent:${parentProduct}"`
          },
          query: `
            query getProducts($first: Int, $query: String) @inContext(language: ${window.ISO_CODE}) {
              products(first: $first, query: $query) {
                edges {
                  node {
                    id
                    title
                    handle
                    variants(first: 20) {
                      nodes {
                        availableForSale
                        currentlyNotInStock
                      }
                    }
                    featuredImage {
                      url
                    }
                    search_color_metafield: metafield(namespace: "akeneo", key: "att_suchfarbe") {
                      value
                    }
                    color_metafield: metafield(namespace: "akeneo", key: "at_farbbezeichnung_des_hers__1") {
                      value
                    }
                  }
                }
              }
            }
          `,
        })
      });

      const data = await response.json();
      const edges = data?.data?.products?.edges || [];

      return edges
        .map(el => ({
          handle: el.node.handle,
          title: el.node.title,
          featuredImage: el.node.featuredImage,
          in_stock: el.node.variants?.nodes?.some(v => v.availableForSale) ?? true,
          search_color: el.node.search_color_metafield?.value,
          color: el.node.color_metafield?.value,
        }))
        .filter(product => product.in_stock); // Nur bestellbare Produkte (availableForSale, auch Weiterverkauf ohne Bestand)
    }
  }

  customElements.define('collection-variant-selector', CollectionVariantSelector);
}
